import { Editor } from '@tiptap/react';
import { TFunction } from 'i18next';

export type EditorAction = {
  command: () => void;
  icon: string;
  title?: string;
};

export const createEditorActions = (editor: Editor, t: TFunction): EditorAction[] => [
  {
    command: () => editor.chain().focus().toggleBold().run(),
    icon: 'bold',
    title: t('content_editor:actions.bold'),
  },
  {
    command: () => editor.chain().focus().toggleItalic().run(),
    icon: 'italic',
    title: t('content_editor:actions.italic'),
  },
  {
    command: () => editor.chain().focus().toggleUnderline().run(),
    icon: 'underline',
    title: t('content_editor:actions.underline'),
  },
  {
    command: () => editor.chain().focus().toggleStrike().run(),
    icon: 'strike',
    title: t('content_editor:actions.strike'),
  },
  {
    command: () => {
      const url = window.prompt('URL');
      if (url) {
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
      }
    },
    icon: 'link',
    title: t('content_editor:actions.link'),
  },
  {
    command: () => editor.chain().focus().toggleOrderedList().run(),
    icon: 'ordered-list',
    title: t('content_editor:actions.ordered_list'),
  },
  {
    command: () => editor.chain().focus().toggleBulletList().run(),
    icon: 'bullet-list',
    title: t('content_editor:actions.bullet_list'),
  },
  {
    command: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
    icon: 'heading-1',
    title: t('content_editor:actions.heading_1'),
  },
  {
    command: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
    icon: 'heading-2',
    title: t('content_editor:actions.heading_2'),
  },
  {
    command: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
    icon: 'heading-3',
    title: t('content_editor:actions.heading_3'),
  },
  {
    command: () => editor.chain().focus().toggleBlockquote().run(),
    icon: 'blockquote',
    title: t('content_editor:actions.blockquote'),
  },
  {
    command: () => editor.chain().focus().toggleCodeBlock().run(),
    icon: 'code-block',
    title: t('content_editor:actions.code_block'),
  },
  {
    command: () => editor.chain().focus().setHorizontalRule().run(),
    icon: 'horizontal-rule',
    title: t('content_editor:actions.horizontal_rule'),
  },
];
